document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("quiz-container");
  const progressBar = document.getElementById("quiz-progress-bar");
  const stepIndicator = document.getElementById("quiz-step-indicator");

  const btnPrev = document.getElementById("quiz-prev");
  const btnNext = document.getElementById("quiz-next");

  const isMobile = window.innerWidth < 600;

  let questions = [];
  let currentStep = 0;
  let answers = {};

  // Fetch quiz JSON
  fetch(window.QUIZ_JSON_URL)
    .then((res) => res.json())
    .then((data) => {
      questions = data;
      renderQuizSteps();
      updateUI();
    });

  /**
   * Render quiz steps as separate screens
   */
  function renderQuizSteps() {
    questions.forEach((q, index) => {
      const step = document.createElement("div");
      step.classList.add("quiz-step");
      step.dataset.step = index;

      if (index !== 0) step.style.display = "none";

      step.innerHTML = `
        <h3>${q.question}</h3>
        ${q.description ? `<p>${q.description}</p>` : ""}
        <div class="quiz-options">
          ${q.choices
            .map((choice) => {
              return `
                <label class="quiz-option">
                  <input type="${q.field_type}" 
                         name="question_${q.id}" 
                         value="${choice.value}">
                  <span>${choice.label}</span>
                </label>
              `;
            })
            .join("")}
        </div>
      `;

      container.appendChild(step);
    });
  }

  /**
   * Step indicator + progress bar + button state
   */
  function updateUI() {
    const total = questions.length;

    stepIndicator.textContent = `Step ${currentStep + 1} of ${total}`;

    const percentage = ((currentStep + 1) / total) * 100;
    progressBar.style.width = percentage + "%";

    btnPrev.disabled = currentStep === 0;
    btnNext.querySelector(".text").textContent = currentStep === total - 1 ? "Submit" : "Next";
  }

  /**
   * Move between steps
   */
  function showStep(stepIndex) {
    document.querySelectorAll(".quiz-step").forEach((step) => {
      step.style.display = step.dataset.step == stepIndex ? "block" : "none";
      if (isMobile) {
        stepIndicator.scrollIntoView();
      }
    });
  }

  /**
   * Validate + store answer for current step
   */
  function validateAndStoreAnswer() {
    const q = questions[currentStep];
    const inputs = document.querySelectorAll(`.quiz-step[data-step="${currentStep}"] input`);

    if (inputs[0].type === "radio") {
      const checked = Array.from(inputs).find((i) => i.checked);
      if (!checked) {
        alert("Please select an answer.");
        return false;
      }
      answers[q.id] = checked.value;
    }

    return true;
  }

  /**
   * Evaluate final variant title & redirect
   */
  function processQuizResults() {
    // Prepare the products object
    const productBundles = {
      completeLawnCare: {
        handle: "complete-lawn-care",
        variants: {
          25: {
            new: "55604452327750",
            existing: "55604452196678",
          },
          50: {
            new: "55604453015878",
            existing: "55604452884806",
          },
          150: {
            new: "55604453704006",
            existing: "55604453572934",
          },
          300: {
            new: "55604453736774",
            existing: "55604453736774",
          },
          500: {
            new: "55604453736774",
            existing: "55604453736774",
          },
        },
      },
      essentials: {
        handle: "essentials",
        variants: {
          25: {
            new: "55650455847238",
            existing: "55650455716166",
          },
          50: {
            new: "55650456535366",
            existing: "55650456404294",
          },
          150: {
            new: "55650457223494",
            existing: "55650457092422",
          },
          300: {
            new: "55650457256262",
            existing: "55650457256262",
          },
          500: {
            new: "55650457256262",
            existing: "55650457256262",
          },
        },
      },
      patchRepair: {
        handle: "patch-repair",
        variants: {
          25: {
            new: "55650493432134",
            existing: "55650493301062",
          },
          50: {
            new: "55650494120262",
            existing: "55650493989190",
          },
          150: {
            new: "55650494808390",
            existing: "55650494677318",
          },
          300: {
            new: "55650494841158",
            existing: "55650494841158",
          },
          500: {
            new: "55650494841158",
            existing: "55650494841158",
          },
        },
      },
    };

    const quizAnswerKeys = ["condition", "size", "colour", "thickness", "moss"];

    const quizAnswers = {};

    // Fetch all the radio input answers
    const quizInputs = document.querySelectorAll(".quiz-step input:checked");

    quizInputs.forEach((quizInput, index) => {
      quizAnswers[quizAnswerKeys[index]] = quizInput.value;
    });

    // Assign Bundle Product
    let bundleProduct = "completeLawnCare";

    // Evaluate if patch problem is present
    if (quizAnswers.thickness == "big_patches" || quizAnswers.thickness == "small_patches") {
      bundleProduct = "patchRepair";
    }

    // Evaluate if moss problem exists
    if (quizAnswers.moss == "no") {
      bundleProduct = "essentials";
    }

    const productBundle = productBundles[bundleProduct];

    // Assign Bundle Quantity
    const bundleQty = quizAnswers.size == "500" ? 2 : 1;

    sessionStorage.setItem("quiz_result_active", "1");

    sessionStorage.setItem("quiz_result_bundle", productBundle.handle);

    sessionStorage.setItem("quiz_result_bundle_qty", bundleQty);

    const redirectUrl = `/products/${productBundle.handle}?variant=${productBundle["variants"][quizAnswers.size][quizAnswers.condition]}&from_quiz=1`;

    window.location.href = redirectUrl;
  }

  // -----------------------------
  // Button Listeners
  // -----------------------------
  btnNext.addEventListener("click", () => {
    if (!validateAndStoreAnswer()) return;

    if (currentStep < questions.length - 1) {
      currentStep++;
      showStep(currentStep);
      updateUI();
    } else {
      // Final submit
      processQuizResults();
    }
  });

  btnPrev.addEventListener("click", () => {
    if (currentStep > 0) {
      currentStep--;
      showStep(currentStep);
      updateUI();
    }
  });
});
